import { render, staticRenderFns } from "./TypeChat.vue?vue&type=template&id=758142ee&"
import script from "./TypeChat.vue?vue&type=script&lang=js&"
export * from "./TypeChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports